import { createFileRoute } from "@tanstack/react-router";
import { Card } from "@acme/ui/card";

export const Route = createFileRoute("/_authed/my-players/$tag/search-filter")({
  component: SearchFilterTab,
});

function SearchFilterTab()
{
  return (
    <Card className="p-8">
      <p className="text-center text-muted-foreground">Search & filter — placeholder. Content coming soon.</p>
    </Card>
  );
}
